import Axios from "axios";

const STORAGE_KEY_PREFIX = "ai-dashboard";

const axios = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_AI_DASHBOARD_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axios.interceptors.request.use((config) => {
    if (typeof window === "undefined") return config;

    const token = localStorage.getItem(`${STORAGE_KEY_PREFIX}.accessToken`);
    const authDataRaw = localStorage.getItem(`${STORAGE_KEY_PREFIX}.authData`);
    const mapToken = localStorage.getItem(`${STORAGE_KEY_PREFIX}.mapToken`);

    const userId = authDataRaw ? (JSON.parse(authDataRaw) as { userId?: string })?.userId : undefined;

    if (token) {
        config.headers = config.headers ?? {};
        config.headers.Authorization = token;
    }

    // if (mapToken) {
    //     config.headers = config.headers ?? {};
    //     config.headers["x-map-token"] = mapToken;
    // }

    if (userId) {
        config.headers = config.headers ?? {};
        (config.headers as any)["x-user-guid"] = userId;
    }

    return config;
});

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;

        if (typeof window !== "undefined" && status === 401) {
            localStorage.removeItem(`${STORAGE_KEY_PREFIX}.authData`);
            localStorage.removeItem(`${STORAGE_KEY_PREFIX}.accessToken`);
            localStorage.removeItem(`${STORAGE_KEY_PREFIX}.profileData`);
            localStorage.removeItem(`${STORAGE_KEY_PREFIX}.mapToken`);
            localStorage.removeItem(`${STORAGE_KEY_PREFIX}.userPreferences`);
            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export { axios };
